"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Grid from "./webflow_modules/Layout/components/Grid";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";
import NavbarBrand from "./webflow_modules/Navbar/components/NavbarBrand";

export function Footer({}) {
  return (
    <Block className={"footer"} tag={"footer"}>
      <Block className={"padding-global"} tag={"div"}>
        <Block className={"container-large"} tag={"div"}>
          <Block className={"padding-vertical padding-xxlarge"} tag={"div"}>
            <Block className={"margin-bottom margin-medium"} tag={"div"}>
              <NavbarBrand
                aria-label={"Navigate to the homepage of the website"}
                className={"footer3_logo-link"}
                options={{
                  href: "/",
                }}
              >
                <Block className={"logo-container-footer"} tag={"div"}>
                  <Image
                    alt={""}
                    className={"navbar2_logo"}
                    height={"auto"}
                    loading={"lazy"}
                    src={
                      "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/656ce0fa2da4744f69f8eadb_Vectors-Wrapper.svg"
                    }
                    width={"Auto"}
                  />
                </Block>
              </NavbarBrand>
            </Block>
            <Grid className={"footer3_top-wrapper"} tag={"div"}>
              <Block
                className={"footer3_left-wrapper"}
                id={"w-node-eeca584d-267e-d72f-fabf-bedad8790353-d879034b"}
                tag={"div"}
              >
                <Block className={"footer3_details-wrapper"} tag={"div"}>
                  <Block tag={"div"}>
                    <Block className={"margin-bottom margin-small"} tag={"div"}>
                      <Block className={"text-size-small"} tag={"div"}>
                        {"Sares Regis Group, Residential, Inc."}
                        <br />
                        {"License #01192016"}
                      </Block>
                    </Block>
                    <Block className={"footer_details-link-list"} tag={"div"}>
                      <Link
                        button={false}
                        className={"footer_details-link"}
                        options={{
                          href: "/privacy-policy",
                        }}
                      >
                        {"Privacy Policy"}
                      </Link>
                      <Link
                        button={false}
                        className={"footer_details-link"}
                        options={{
                          href: "/website-disclaimer",
                        }}
                      >
                        {"Website Disclaimer"}
                      </Link>
                      <Link
                        button={false}
                        className={"footer_details-link"}
                        options={{
                          href: "/disclosures-and-licenses",
                        }}
                      >
                        {"Disclosures & Licenses"}
                      </Link>
                      <Link
                        button={false}
                        className={"footer_details-link"}
                        options={{
                          href: "https://privacyportal.onetrust.com/webform/c485392c-9ffa-408e-80f2-3b9bdc8de724/0b23fc21-9c92-4464-af60-fa0f6936192c",
                        }}
                      >
                        {"Do Not Sell My Personal Information"}
                      </Link>
                      <Link
                        button={false}
                        className={"footer_details-link"}
                        options={{
                          href: "/accessibility-statement",
                        }}
                      >
                        {"Accessibility Statement"}
                      </Link>
                      <Link
                        button={false}
                        className={"footer_details-link"}
                        options={{
                          href: "https://www.lineups.io",
                          target: "_blank",
                        }}
                      >
                        {"Made by Lineups"}
                      </Link>
                    </Block>
                  </Block>
                  <Block tag={"div"}>
                    <Block className={"margin-bottom margin-small"} tag={"div"}>
                      <Link
                        block={"inline"}
                        button={false}
                        className={"footer_details-link"}
                        options={{
                          href: "#",
                        }}
                      >
                        <Block className={"text-size-small"} tag={"div"}>
                          {"Contact Us"}
                        </Block>
                      </Link>
                    </Block>
                    <Block className={"footer_details-link-list"} tag={"div"}>
                      <Link
                        button={false}
                        className={"footer_details-link"}
                        options={{
                          href: "tel:949.756.5959",
                        }}
                      >
                        {"949.756.5959"}
                      </Link>
                      <Block className={"div-block-31"} tag={"div"}>
                        <HtmlEmbed
                          className={"icon-embed-custom"}
                          content={
                            '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewbox="0 0 24 17" fill="none" preserveaspectratio="xMidYMid meet" aria-hidden="true" role="img">\n<g clip-path="url(#clip0_214_3247)">\n<path d="M11.911 0L0 5.90525V8.67917H1.33317V17.0001H22.3993V8.67917H24.0001V5.90525L11.911 0ZM19.8219 14.494H19.8218H3.91091V6.88942L11.911 2.77382L19.8219 6.88942V14.494Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M15.5545 9.57312H8.17773V6.88953H15.5545V9.57312ZM15.5545 13.4222H8.17773V10.7368H15.5545V13.4222Z" fill="currentColor"/>\n</g>\n<defs>\n<clippath id="clip0_214_3247">\n<rect width="24" height="17" fill="currentColor"/>\n</clippath>\n</defs>\n</svg>'
                          }
                        />
                        <HtmlEmbed
                          className={"icon-embed-custom-2"}
                          content={
                            '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewbox="0 0 16 17" fill="none" preserveaspectratio="xMidYMid meet" aria-hidden="true" role="img">\n<g clip-path="url(#clip0_214_3250)">\n<path d="M9.93589 11.9626C9.68221 13.99 7.89168 15.5684 5.72526 15.5684C3.38479 15.5684 1.48131 13.7288 1.48131 11.4669C1.48131 10.1964 2.08309 9.05826 3.02372 8.30668V6.59058C1.22578 7.52468 0 9.36068 0 11.4669C0 14.5179 2.56822 16.9999 5.72526 16.9999C8.11943 16.9999 10.1747 15.5719 11.0284 13.5498L9.93774 11.9626H9.93589Z" fill="currentColor"/>\n<path d="M15.2947 12.9844L14.1133 13.7718L11.0766 8.85789L5.24767 8.89011V7.72337H8.33435V6.47074H5.24767V3.57537C5.96795 3.31053 6.48271 2.63768 6.48271 1.84853C6.48271 0.826737 5.6254 0 4.56997 0C3.51453 0 2.65723 0.828526 2.65723 1.84853C2.65723 2.66095 3.19976 3.34989 3.95337 3.59684V10.1087L10.36 10.1159L13.68 15.4915L16.002 14.0348L15.2965 12.9844H15.2947Z" fill="currentColor"/>\n</g>\n<defs>\n<clippath id="clip0_214_3250">\n<rect width="16" height="17" fill="currentColor"/>\n</clippath>\n</defs>\n</svg>'
                          }
                        />
                      </Block>
                      <Link
                        button={false}
                        className={"footer_details-link"}
                        options={{
                          href: "/",
                        }}
                      >
                        {"© 2023 Copyright SRG Residential"}
                      </Link>
                    </Block>
                  </Block>
                </Block>
              </Block>
              <Grid
                className={"footer3_menu-wrapper"}
                id={"w-node-eeca584d-267e-d72f-fabf-bedad8790370-d879034b"}
                tag={"div"}
              >
                <Block className={"footer3_link-list"} tag={"div"}>
                  <Link
                    button={false}
                    className={"footer3_link"}
                    options={{
                      href: "#",
                    }}
                  >
                    {"Find Your Home"}
                  </Link>
                  <Link
                    button={false}
                    className={"footer3_link"}
                    options={{
                      href: "/residents",
                    }}
                  >
                    {"Residents"}
                  </Link>
                  <Link
                    button={false}
                    className={"footer3_link"}
                    options={{
                      href: "/applicants",
                    }}
                  >
                    {"Applicants"}
                  </Link>
                  <Link
                    button={false}
                    className={"footer3_link"}
                    options={{
                      href: "https://careers-sares-regis.icims.com/jobs/intro?hashed=-435627079&mobile=false&width=940&height=500&bga=true&needsRedirect=false&jan1offset=-360&jun1offset=-300",
                      target: "_blank",
                    }}
                  >
                    {"Careers"}
                  </Link>
                  <Link
                    button={false}
                    className={"footer3_link"}
                    options={{
                      href: "/contact-us",
                    }}
                  >
                    {"Contact"}
                  </Link>
                </Block>
              </Grid>
            </Grid>
          </Block>
        </Block>
      </Block>
    </Block>
  );
}
